/* FullPageToolbarNext.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./FullPageToolbarNext.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl-next';
import { ContextPanelConsumer } from '@atlaskit/editor-common/context-panel';
import { TOOLBARS } from '@atlaskit/editor-common/toolbar';
import { ToolbarArrowKeyNavigationProvider } from '@atlaskit/editor-common/ui-menu';
import { fg } from '@atlaskit/platform-feature-flags';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
import { isToolbar } from '../../../utils/toolbar';
import { ToolbarNext } from '../../Toolbar/Toolbar';
import { ToolbarPortalMountPoint, useToolbarPortal } from '../../Toolbar/ToolbarPortal';
var styles = {
  mainToolbarIconBefore: "_19pkpxbi _2hwxpxbi _otyrpxbi",
  mainToolbarIconBeforeNew: "_4cvr1h6o _1e0c1txw",
  mainToolbarWrapper: "_1rjc12x7 _18zrutpp _n7zlia51",
  mainToolbarNew: "_1e0c1txw _4t3izwfg",
  mainToolbarZIndex: "_1pby16oo _kqswh2mm",
  mainToolbarWithKeyline: "_16qs1nax",
  customToolbarWrapperStyle: "_4cvr1h6o _1e0c1txw",
  firstChildWrapperOneLine: "_1e0c1txw _16jlkb7n",
  secondChildWrapperOneLine: "_1e0c1txw _1ul91ns9 _4cvr1h6o",
  beforePrimaryToolbarComponents: "_1e0c1txw _16jlkb7n _1bahesu3 _4cvr1h6o"
};
var MainToolbarWrapper = function MainToolbarWrapper(_ref) {
  var children = _ref.children,
    testId = _ref.testId,
    showKeyline = _ref.showKeyline;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testId,
    className: ax([styles.mainToolbarWrapper, showKeyline && styles.mainToolbarWithKeyline, expValEquals('platform_editor_toolbar_support_custom_components', 'isEnabled', true) && styles.mainToolbarNew, expValEquals('platform_editor_toolbar_aifc_patch_3', 'isEnabled', true) && styles.mainToolbarZIndex])
  }, children);
};
var FirstChildWrapper = function FirstChildWrapper(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "main-toolbar-first-child-wrapper",
    className: ax([styles.firstChildWrapperOneLine])
  }, children);
};
var SecondChildWrapper = function SecondChildWrapper(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "main-toolbar-second-child-wrapper",
    className: ax([styles.secondChildWrapperOneLine])
  }, children);
};
export var FullPageToolbarNext = function FullPageToolbarNext(_ref4) {
  var _editorAPI$toolbar, _useToolbarPortal;
  var editorAPI = _ref4.editorAPI,
    beforeIcon = _ref4.beforeIcon,
    toolbarDockingPosition = _ref4.toolbarDockingPosition,
    editorView = _ref4.editorView,
    popupsMountPoint = _ref4.popupsMountPoint,
    showKeyline = _ref4.showKeyline,
    customPrimaryToolbarComponents = _ref4.customPrimaryToolbarComponents,
    disabled = _ref4.disabled;
  var components = editorAPI === null || editorAPI === void 0 || (_editorAPI$toolbar = editorAPI.toolbar) === null || _editorAPI$toolbar === void 0 ? void 0 : _editorAPI$toolbar.actions.getComponents();
  var intl = useIntl();
  var toolbar = components === null || components === void 0 ? void 0 : components.find(function (component) {
    return component.key === TOOLBARS.PRIMARY_TOOLBAR;
  });

  // When a toolbar portal context is provided, render the  toolbar inside a portal.
  // Otherwise fall back to a fragment just to avoid forking rendering logic.
  var _ref5 = (_useToolbarPortal = useToolbarPortal()) !== null && _useToolbarPortal !== void 0 ? _useToolbarPortal : {
      Portal: React.Fragment
    },
    ToolbarPortal = _ref5.Portal;
  var hasToolbarPortal = ToolbarPortal !== React.Fragment;
  var mountPoint = hasToolbarPortal ? undefined : popupsMountPoint;
  var isShortcutToFocusToolbar = useCallback(function (event) {
    //Alt + F9 to reach first element in this main toolbar
    return event.altKey && event.key === 'F9';
  }, []);
  var handleEscape = useCallback(function (event) {
    if (!(editorView !== null && editorView !== void 0 && editorView.hasFocus())) {
      editorView === null || editorView === void 0 || editorView.focus();
    }
    event.preventDefault();
    event.stopPropagation();
  }, [editorView]);
  return /*#__PURE__*/React.createElement(ContextPanelConsumer, null, function (_ref6) {
    var ContextPanelWidth = _ref6.width;
    return /*#__PURE__*/React.createElement(ToolbarArrowKeyNavigationProvider, {
      editorView: editorView,
      childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
      isShortcutToFocusToolbar: isShortcutToFocusToolbar,
      handleEscape: handleEscape,
      intl: intl
    }, /*#__PURE__*/React.createElement(ToolbarPortal, null, /*#__PURE__*/React.createElement(MainToolbarWrapper, {
      testId: "ak-editor-main-toolbar",
      showKeyline: showKeyline || ContextPanelWidth > 0
    }, beforeIcon && /*#__PURE__*/React.createElement("div", {
      className: ax([styles.mainToolbarIconBefore, expValEquals('platform_editor_toolbar_support_custom_components', 'isEnabled', true) && styles.mainToolbarIconBeforeNew])
    }, beforeIcon), expValEquals('platform_editor_toolbar_support_custom_components', 'isEnabled', true) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FirstChildWrapper, null, toolbarDockingPosition !== 'none' && components && isToolbar(toolbar) && (!expValEquals('platform_editor_toolbar_aifc_patch_3', 'isEnabled', true) || editorView) && /*#__PURE__*/React.createElement(ToolbarNext, {
      toolbar: toolbar,
      components: components,
      editorView: editorView,
      editorAPI: editorAPI,
      popupsMountPoint: mountPoint,
      editorAppearance: "full-page",
      isDisabled: disabled
    })), /*#__PURE__*/React.createElement(SecondChildWrapper, null, /*#__PURE__*/React.createElement("div", {
      className: ax([styles.customToolbarWrapperStyle])
    }, !!customPrimaryToolbarComponents && 'before' in customPrimaryToolbarComponents && /*#__PURE__*/React.createElement("div", {
      "data-testid": 'before-primary-toolbar-components-plugin',
      className: ax([styles.beforePrimaryToolbarComponents])
    }, customPrimaryToolbarComponents.before), !!customPrimaryToolbarComponents && 'after' in customPrimaryToolbarComponents ? customPrimaryToolbarComponents.after : customPrimaryToolbarComponents)), fg('platform_editor_toolbar_aifc_patch_7') && /*#__PURE__*/React.createElement(ToolbarPortalMountPoint, null)) : toolbarDockingPosition !== 'none' && components && isToolbar(toolbar) && (!expValEquals('platform_editor_toolbar_aifc_patch_3', 'isEnabled', true) || editorView) && /*#__PURE__*/React.createElement(ToolbarNext, {
      toolbar: toolbar,
      components: components,
      editorView: editorView,
      editorAPI: editorAPI,
      popupsMountPoint: mountPoint,
      editorAppearance: "full-page",
      isDisabled: disabled
    }))));
  });
};